export default __webpack_public_path__ + "static/media/play-arrow.a0d85f60.svg";